<h2 mat-dialog-title class="mp-title">
  <mat-icon>tune</mat-icon>
  <span>Manage AI Providers</span>
</h2>

<mat-dialog-content class="mp-content">

  <div *ngIf="loading" class="mp-state">
    <mat-spinner diameter="28"></mat-spinner>
    <span>Loading providers…</span>
  </div>

  <div *ngIf="!loading && loadError" class="mp-state error">
    <mat-icon>error_outline</mat-icon>
    <span>Couldn't load providers.</span>
    <button mat-stroked-button color="warn" type="button" (click)="load()">Retry</button>
  </div>

  <div *ngIf="!loading && !loadError && providers.length === 0" class="mp-state">
    <mat-icon>info_outline</mat-icon>
    <span>No AI providers are configured.</span>
  </div>

  <mat-accordion multi *ngIf="!loading && !loadError && providers.length > 0">
    <mat-expansion-panel *ngFor="let p of providers" class="mp-panel" [class.disabled]="!p.isEnabled">
      <mat-expansion-panel-header collapsedHeight="56px" expandedHeight="56px">
        <mat-panel-title class="mp-panel-title">
          <span class="mp-name-text">{{ p.name }}</span>
          <span class="mp-dirty-dot" *ngIf="p.dirty" title="Unsaved changes"></span>
        </mat-panel-title>
        <mat-panel-description class="mp-panel-desc">
          <span class="mp-type">{{ p.typeLabel }}</span>
          <span class="mp-status" [class.on]="p.isEnabled">{{ p.isEnabled ? 'Enabled' : 'Disabled' }}</span>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <div class="mp-enable-row">
        <span class="mp-enable-label">Provider</span>
        <mat-slide-toggle [checked]="p.isEnabled"
                          (change)="toggleEnabled(p, $event.checked)">
          {{ p.isEnabled ? 'Enabled' : 'Disabled' }}
        </mat-slide-toggle>
      </div>

      <div class="mp-section-label">Actions</div>
      <div class="mp-actions">
        <mat-slide-toggle *ngFor="let a of p.actions"
                          class="mp-action"
                          [checked]="a.enabled"
                          [disabled]="!p.isEnabled"
                          (change)="toggleAction(p, a, $event.checked)">
          {{ a.label }}
        </mat-slide-toggle>
      </div>

      <ng-container *ngIf="!p.isJai">
        <div class="mp-section-label">Bulk copy batch</div>
        <div class="mp-actions">
          <mat-slide-toggle class="mp-action"
                            [checked]="p.pollBatch"
                            [disabled]="!p.isEnabled"
                            (change)="togglePollBatch(p, $event.checked)">
            {{ p.pollBatch ? 'Poll batch to completion' : 'Save pending, poll per offer' }}
          </mat-slide-toggle>
        </div>
      </ng-container>

      <div class="mp-section-label">Configuration <span class="mp-readonly">(view only)</span></div>

      <div class="mp-config-warning" *ngIf="!p.configParsed">
        <mat-icon>warning_amber</mat-icon>
        <span>Config isn't valid JSON — actions can't be saved until it's fixed.</span>
      </div>

      <div class="mp-config" *ngIf="p.configParsed">
        <div class="mp-config-row" *ngFor="let row of p.configRows">
          <span class="mp-config-label">{{ row.label }}</span>
          <span class="mp-config-value" [class.muted]="row.value === '—'">{{ row.value }}</span>
        </div>
      </div>

      <div class="mp-card-actions">
        <span class="mp-dirty" *ngIf="p.dirty">Unsaved changes</span>
        <button mat-flat-button color="primary" type="button"
                [disabled]="!canSave(p)"
                (click)="save(p)">
          {{ p.saving ? 'Saving…' : 'Save' }}
        </button>
      </div>
    </mat-expansion-panel>
  </mat-accordion>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="close()">Close</button>
</mat-dialog-actions>
